import { Icon } from 'util/ui'

export default function NavigatableIntegrationListItem({
  onClick,
  subTitle,
  title,
}) {
  return (
    <div
      className="NavigatableIntegrationWidgetCard-ListItem"
      onClick={onClick}
    >
      <div className="NavigatableIntegrationWidgetCard-ListItem-titleAndSubTitleColumn">
        <div className="NavigatableIntegrationWidgetCard-ListItem-title">
          {title}
        </div>
        <div className="NavigatableIntegrationWidgetCard-ListItem-subTitle">
          {subTitle}
        </div>
      </div>
      <div className="NavigatableIntegrationWidgetCard-ListItem-iconColumn">
        <Icon name="chevron right" />
      </div>
    </div>
  )
}
